import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const location = useLocation();

  const hideOn = ["/login", "/register"];
  if (hideOn.includes(location.pathname)) {
    return null; 
  }

  return (
    <footer className="bg-gray-900 text-gray-300 mt-10 pt-8 pb-4">
      <div className="max-w-6xl mx-auto px-6">

        <p className="text-center text-sm mt-1 text-gray-400">
          "We value your time and financial growth."
        </p>
        
        <div className="flex justify-center gap-6 mt-5 text-sm">
          <Link className="hover:text-white" to="/">Home</Link>
        </div>
      </div>
    </footer>
  );
}
